(function () {
    'use strict';

    angular
        .module('app')
        .controller('acquirecheckoutonelib', acquirecheckoutonelib);

    acquirecheckoutonelib.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];

    function acquirecheckoutonelib($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService) {

        // =====================================
        // On Load.
        // =====================================

        /* jshint validthis:true */
        var vm = this;
        vm.title = 'acquirecheckoutonelib';

        scope.acquireCheckOutOneLibDialogShown = false;

        scope.ACN_ASSUME_OWNERSHIP = 127

        //scope.xyz = { bReadyForOK: false, bCopyDataCard: false, selectedLibraryItem: {}};

        scope.$on('acquireCheckOutOneLibButtonClicked', function (event, arg) {
            scope.onAcquireCheckOutOneLibButtonClicked(arg.slx);
        });

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //
        // Enables.
        //
        scope.doEnables = function () {
            // If no library is selected, ...
            if (scope.xyz.selectedLibraryItem == null
                || scope.xyz.selectedLibraryItem.libId == null
                || scope.xyz.selectedLibraryItem.libId.length <= 0
                ) {
                scope.xyz.bReadyForOK = false;
                return;
            }
            // else, enable OK.
            scope.xyz.bReadyForOK = true;
        }

        // On click of the Assign button.
        scope.onAcquireCheckOutOneLibButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.xyz = { bReadyForOK: false, bCopyDataCard: false, selectedLibraryItem: {} };

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["ACQUIRE_CHECK_OUT_ONELIB"];
            scope.selectLibraryLabel = loginService.resourceStrings["SELECT_LIBRARY_LABEL"];
            scope.copyDataCardLabel = loginService.resourceStrings["COPY_DATA_CARD_AS_WELL"];
            scope.filesLabel = loginService.resourceStrings["ACQUIRE_CHECK_OUT_ONELIB_FILES"];
            scope.filesLabel = scope.filesLabel.replace("{0}", scope.slx.list.length);
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Library picker.
            //scope.libraryArray = [];
            //scope.libraryArray.push({ id: '8b1ac657-5c9c-4563-bca0-379e38f42345', name: 'AFS-Checked' });
            //scope.libraryArray.push({ id: 'eea08b8a-cae0-463f-bb65-06e1dab219d0', name: 'AFS-Unchecked' });
            //scope.libraryArray.push({ id: '7f02b667-536c-46ad-8353-ba02225c9acd', name: 'AFS-Unchecked-AutoRev' });

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename
                });
                index++;
            });

            // Enables.
            //scope.selectItem();
            // Do modal.
            scope.acquireCheckOutOneLibDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };


        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            scope.gridOptions.columnDefs[0].name = colName;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        // =====================================
        // User interaction.
        // =====================================

        //
        // On library change.
        //
        scope.selectedLibraryChanged = function (name, id, item) {

            scope.xyz.selectedLibraryItem = item;

            // Do Enables.
            scope.doEnables();
        }

        // =====================================
        // OK, Cancel.
        // =====================================

        scope.onAcquireCheckOutOneLibDialogOK = function () {
            scope.xyz.processing = true;

            var libId = scope.xyz.selectedLibraryItem.libId;

            angular.forEach(scope.slx.list, function (item) {
                item.commandParams.eLibId = libId;
                item.commandParams.ebCopyDataCard = scope.xyz.bCopyDataCard;
            });

            // Execute.
            selectionCommandService.AcquireCheckOut(scope.slx).then(function (response) {
                // Handle errors.
                var atLeastOneError = false;
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                // Close dialog and refresh grid.
                $mdDialog.hide();
                scope.xyz.processing = false;
                gridDataService.updateGridRecords(slx.list);

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            }, function (response) {
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
            });
        };

        scope.onAcquireCheckOutOneLibDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.acquireCheckOutOneLibDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            scope.onAcquireCheckOutOneLibButtonClicked(records);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
